import type { TablePaginationConfig } from '@/components';

export const DEFAULT_PAGINATION_SETTING: TablePaginationConfig = {
  pageSize: 50,
  showSizeChanger: false,
};
